import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getCompanyType, getESGReqHeader, getFormErrorMessage } from "../../utility/service/tool-service";
import { Button } from "primereact/button";
import { Tooltip } from 'primereact/tooltip';
import AddReg from "./AddReg";
import { checkLoading, SystemLoading } from "../../store/loadingStore";
import { F1010205Before, createDataRegister, deleteDataRegister, downloadDataRegister, getDataRegisterList } from "../../utility/service/dataRegister-service";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { getCompanyPlaceList } from "../../utility/service/carbon-service";

import PrimeDialog from "../../components/dialog/PrimeDialog";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { downloadFile } from "../../utility/service/download-service";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import NoInfo from "../../components/NoInfo";
import { addFormValidator } from "../../utility/validate/formValidator";
//資料登錄 查詢頁面
const DataReg_Index = () => {

  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const currentYear = new Date().getFullYear() + 10;
  const currentMinGuoYear = new Date().getFullYear() - 1911 + 10;
  const [addDialog, setAddDialog] = useState(false);
  const [delDialog, setDelDialog] = useState(false);
  const [delTitle, setDelTitle] = useState("");
  const [delObj,setDelObj] = useState({});
  const [delContent, setDelContent] = useState("");
  const [planYearList,setPlanYearList] = useState([]);//盤查年度
  const fileInputRef = useRef(null);
  const [companyPlaceList,setCompanyPlaceList] = useState([]);//組織邊界廠商清單查詢



  const [caseList, setCaseList] = useState([]);
  const [cfvUploadLogSeq,setCfvUploadLogSeq] = useState('');//查看更多分頁 key
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗 
  const [isLoading,setIsLoading] =  useState(true);
  const [confirmLoad,setConfirmLoad] = useState(false);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [tempQuery,setTempQuery] = useState({});
  
  
 

  
  

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    trigger,
    reset: resetForm,
    control,
    reset,
    formState: { errors, isValid, isDirty }
  } = useForm({
    defaultValues: {
    },
    //錯誤驗證時機
    mode: "all"
  });


  const watchCompanySeq = watch("companySeq"); //為了避免下拉選單沒選而觸發表單驗證 新增時disabled此欄位 並且用watch 取得值
  
  


  const onSubmit = (data) => {
    let reqBody = {
      companySeq:data.companySeq,
      placeSeq:data.placeSeq,
      startYear:data.startYear,
      endYear:data.endYear,
    }
    axios_getDataRegisterList(reqBody);
  }

  const orderNoTemplate = (data, props) => {
    return (
      <span>
        {props.rowIndex + 1}
      </span>
    )
  }

  //重新排序 => 可以用dataTable的排序，先註解掉
  // const doSort = useCallback((sortType, dataList) => {
  //   let sortedDataList = [...dataList]
  //   sortedDataList = [...dataList].sort((a, b) => {
  //     const timestampA = parseInt(a.uploadDate, 10)
  //     const timestampB = parseInt(b.uploadDate, 10)
  //     return sortType === "asc"
  //       ? timestampA - timestampB
  //       : timestampB - timestampA
  //   })

  //   return sortedDataList
  // }, []);



  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
            <Button rounded text severity="secondary" 
              className="p-button-icon-only" 
              tooltip={t('button.download')} tooltipOptions={{ position: 'top' }}
              onClick={() => { downloadItem(rowData) }}>
              <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
            </Button>
            <Button rounded text severity="secondary" 
              className="p-button-icon-only" 
              tooltip={t('button.delete')} tooltipOptions={{ position: 'top' }}
              onClick={() => { deleteItem(rowData) }}>
              <FontAwesomeIcon icon="fa-solid fa-trash" />
            </Button>
        </>

      )

    }
  }

  const addDatReg = () => {
    setAddDialog(true);
    //清空原有的值
    setValue("add_placeSeq" ,"" ,{ shouldValidate: true });
    setValue("add_year" ,"" ,{ shouldValidate: true });
    setValue("add_file" ,"" ,{ shouldValidate: true });
    setTempQuery({
      companySeq: getValues("companySeq"),
      placeSeq: getValues("placeSeq")
    })
    reset((pre)=>{
      return {
        ...pre,

      }
    })
    
    
  }


  const deleteItem = (rowData) => {
    setDelObj(rowData)
    setDelTitle(t('button.delete'));
    setDelContent(`${t('caseNo')}: ${rowData.caseSn}`);
    setDelDialog(true);
  }

  const downloadItem = (rowData) => {
    downloadDataRegister({
      caseSn:rowData.caseSn,
      companySeq:rowData.companySeq,
      year:rowData.year
    })
    .then((res)=>{
        //在此處理download File
        handleFileDownloadRes(res,`${rowData.caseSn}.xlsx`)
       
    })
  }

  const checkKeyDown = (e) => {
    // if (e.key === 'Enter') e.preventDefault();
    if (e.keyCode === 13) {
      e.stopPropagation();
    }
  };

  const handleCompanySeqChange = (val)=>{
    if(val){
      setValue("placeSeq","");
    }

  }

  const axios_getDataRegisterList = (reqBody,readMore=false)=>{
    checkLoading(loading);
    getDataRegisterList(reqBody)
      .then(res=>{
        if(checkDpSuccess(res)){
            if(res.data.RespBody.caseList?.length > 0){
              setCfvUploadLogSeq(res.data.RespBody.caseList[res.data.RespBody.caseList?.length-1].cfvUploadLogSeq);
              if(readMore===true){
                setCaseList((pre)=>{
                  return [...pre,...res.data.RespBody.caseList]
                })
              }else{
                setCaseList(res.data.RespBody.caseList)
              }
            }else{
              if(readMore===false){
                setCaseList([]);
              }
            }
        }else{
          if(readMore==false){
            setCaseList([]);
          }
        }
      })
      .finally(fin=>{ checkLoading(loading, false);})

  }

    //查詢更多
    const btnReadMore = () => {
      let reqBody = {
        companySeq:getValues("companySeq"),
        placeSeq:getValues("placeSeq"),
        startYear:getValues("startYear"),
        endYear:getValues("endYear"),
        cfvUploadLogSeq:cfvUploadLogSeq
      }
      axios_getDataRegisterList(reqBody,true);
    };

  //取得組織邊界廠商清單 & 盤查年度
  const axios_getCompanyPlaceAndPlanYearList = ()=>{
    
    //組織邊界廠商清單
    setIsLoading(true);
    getCompanyPlaceList()
      .then((res)=>{
        if(checkDpSuccess(res)){
          let data = res.data.RespBody.companyPlaceList
          setCompanyPlaceList(data);
          if(getCompanyType()==='A'){
            setValue("companySeq",data[0]?.companySeq, {shouldValidate:true});
            if(getCompanyType()==='A'){
              let reqBody = {
                    companySeq:data[0]?.companySeq
               }
               if(location?.state?.caseSn){
                  let placeList = data?.filter((item)=>item.companySeq===data[0]?.companySeq)?.[0].placeList;
                  let placeSel = placeList?.filter((item)=>item.placeName === location?.state?.caseSn?.placeName);
                  if(placeSel?.length > 0){
                      setValue("placeSeq",placeSel[0]?.placeSeq, {shouldValidate:true});
                      reqBody.placeSeq = placeSel[0]?.placeSeq;
                      axios_getDataRegisterList(reqBody);
                  }
               }else{
                    axios_getDataRegisterList(reqBody);
               }
              }
              
          }else{
            if(location?.state!==null){

              setValue("companySeq",data?.filter((item)=>item.companyName===location?.state?.companyName)?.[0]?.companySeq, {shouldValidate:true});
              
              let placeList = data?.filter((item)=>item.companyName===location?.state?.companyName)?.[0].placeList; //這行會有問題
              let placeSel = placeList?.filter((item)=>item.placeName === location?.state?.caseSn?.placeName);
              if(placeSel?.length > 0){
                setValue("placeSeq",placeSel[0]?.placeSeq, {shouldValidate:true});
                let reqBody = {
                  companySeq:data?.filter((item)=>item.companyName===location?.state?.companyName)?.[0]?.companySeq,
                  placeSeq:placeSel[0]?.placeSeq
                }
                axios_getDataRegisterList(reqBody);
              }

              
              

            }
            
          }
        }
      }).finally((fin)=>setIsLoading(false))
    //盤查年度
    getSubItemsByItemNo('CFV_PLAN_YEAR',0)
    .then((res)=>{
        if(checkDpSuccess(res)){
            let data = res.data.RespBody.subItems;
            let newArray = data.map((item, index) => {
              return {
                ...item,
                index: index,
              }
            })
            setPlanYearList(newArray);
        }
    })  
  }

  //確認刪除
  const confirmDel = () => {
    checkLoading(loading);
    let reqBody = {
      caseSn: delObj?.caseSn
    }
    deleteDataRegister(reqBody).then(res => {
        if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t('button.delete') + ' ' + t('message.success'));
            let reqBody = {
              companySeq:getValues("companySeq"),
              placeSeq:getValues("placeSeq"),
              startYear:getValues("startYear"),
              endYear:getValues("endYear")
            }
            axios_getDataRegisterList(reqBody);
        }
        setDelDialog(false);
    }).finally((fin)=>{checkLoading(loading, false);})
}


//確認新增
const confirmAddReg = ()=>{
    setConfirmLoad(true);
    checkLoading(loading);
    const formData = new FormData();
    formData.append("companySeq", getValues("add_companySeq"));
    formData.append("placeSeq", getValues("add_placeSeq"));
    formData.append("year", getValues("add_year"));
    formData.append("file",fileInputRef.current?.files[0]);
    createDataRegister(formData)
      .then((res)=>{
        if(checkDpSuccess(res)){
          handleSuccessMessage(dispatch, t('button.create') + ' ' + t('message.success'));
          setAddDialog(false);
            let tempCompanySeq = tempQuery?.companySeq;
            let tempPlaceSeq = tempQuery?.placeSeq
  
            if(tempCompanySeq!==''&& tempCompanySeq!==undefined){ //有選組織名稱才預設call 查詢清單
              let reqBody = {
                companySeq:tempCompanySeq,
                placeSeq:tempPlaceSeq,
                startYear:getValues("startYear"),
                endYear:getValues("endYear")
              }
              
              axios_getDataRegisterList(reqBody);
            }
         
      
        
        }
      }).finally(fin=>{ 
        checkLoading(loading, false);
        setConfirmLoad(false);
      })
}


  useEffect(() => {
    axios_getCompanyPlaceAndPlanYearList();
    axios_getCreateBefore();//統一檢核驗證

  }, [])

      //建立前查詢form 規則
      const axios_getCreateBefore = ()=>{
        F1010205Before()
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let array = []
                    res?.data?.RespBody?.constraints?.forEach((item) => {
                        const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                        array.push(result)
                    })
                    setFormRule(array);
                }
            })
    }

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);

  const handleCaseSnLink = (rowData)=>{
    navigate("/management/dashboard",{ state: { 
      companyName: rowData.uploaderCompanyName,
      companySeq:rowData?.companySeq,
      caseSn:{
        year:rowData.year,
        placeName:rowData.placeName,
        caseSn:rowData.caseSn},
       } })
  }

  return (
    <>
      {/* 返回上頁 */}
     <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { navigate("/management/dashboard/",location) }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.back')}
            </Button>
        </div>
    </div>
      {/* 上方區塊 */}
      <div className="p-card bg-gray">
        <div className="p-card-body">
          {/* 如果要強置換行就用<div className="grid"></div>包起來，以下範例
              <form>
                <div className="grid">
                  <element className="col-4">第一排元素</element>
                  <element className="col-4">第一排元素</element>
                </div>
                <div className="grid">
                  <element className="col-4">第二排元素</element>
                  <element className="col-4">第二排元素</element>
                </div>
              </form>
          */}
          {/* 如果要自然換行就用<form className="grid"></form>包起來不需要中間再包div，以下範例
              <form className="grid">
                <element className="col-4">元素</element>
                <element className="col-4">元素</element>
                <element className="col-4">元素</element>
                <element className="col-4">元素</element>
              </form>
          */}

          {/* col-* 的用法，請看
              一般用法：https://primeflex.org/gridsystem#twelwecolumngrid
              RWD用法：https://primeflex.org/gridsystem#responsive
          */}

          <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
            {/* 第一排 */}
            <div className="grid">
              {/* 廠商名稱 */}
              <div className="col-12 lg:col-4">
                {/* 必填class required */}
                <label
                  htmlFor="companySeq"
                  className="form-label required">
                  {t('organName')}
                </label>
                <Controller
                  name="companySeq"
                  control={control}
                  disabled={addDialog}
                  rules={{ required: { value: true, message: t('validation.required') } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={addDialog}
                      loading={isLoading.toString()==='true'?1:0}
                      filter
                      showClear
                      optionLabel="companyName"
                      optionValue="companySeq"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="companySeq"
                      control={control}
                      options={companyPlaceList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                        handleCompanySeqChange(event.value);
                        
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "companySeq")}
              </div>

              {/* 場所名稱 */}
              <div className="col-12 lg:col-4">
                <label
                  htmlFor="placeName"
                  className="form-label">
                  {t('place_name')}
                </label>
                <Controller
                  name="placeSeq"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      showClear
                      appendTo={"self"}
                      optionLabel="placeName"
                      optionValue="placeSeq"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs_all")}
                      name="placeSeq"
                      control={control}
                      options={companyPlaceList?.filter((item)=>item.companySeq===watch("companySeq"))[0]?.placeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "placeSeq")}
              </div>
            </div>

            {/* 第二排 盤查年度起迄(民國) */}
            <div className="grid">
              <div className="col-12 lg:col-8">
                <label
                  htmlFor="placeName"
                  className="form-label">
                  {t('startYear_endYear_roc')}
                </label>
                <div className="col-date-picker">
                  <Controller
                    name="startYear"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        showClear
                        appendTo={"self"}
                        optionLabel="subitemName"
                        optionValue="subitemNo"
                        value={field.value}
                        virtualScrollerOptions={{ itemSize: 40 }}
                        defaultValue={""}
                        placeholder={t("plz_chs_all")}
                        name="startYear"
                        control={control}
                        options={planYearList}
                        className={classNames({ "p-invalid": fieldState.error })}
                        onChange={(event) => {
                          field.onChange(event.value);
                        }}
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "startYear")}
                  <Controller
                    name="endYear"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        showClear
                        appendTo={"self"}
                        optionLabel="subitemName"
                        optionValue="subitemNo"
                        value={field.value}
                        virtualScrollerOptions={{ itemSize: 40 }}
                        defaultValue={""}
                        placeholder={t("plz_chs_all")}
                        name="endYear"
                        control={control}
                        options={planYearList}
                        className={classNames({ "p-invalid": fieldState.error })}
                        onChange={(event) => {
                          field.onChange(event.value);
                        }}
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "endYear")}
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="col-12 gap-2 flex-all-center">
                <Button type="submit" label={t("button.query")} />
                <Button outlined onClick={() => { addDatReg() }} type="button" label={t("button.add")} />
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* 下方 Table */}
      <div className="p-card">
        <div className="p-card-body">
          {/* <div className="field text-right">
            <Controller
              name="sortType"
              control={control}
              render={({ field, fieldState }) => (
                <Dropdown
                  appendTo={"self"}
                  optionLabel="label"
                  optionValue="value"
                  value={field.value}
                  defaultValue={""}
                  placeholder={t("plz_chs")}
                  name="sortType"
                  control={control}
                  options={[{ label: t('old_to_new'), value: 'asc' }, { label: t('new_to_old'), value: 'desc' }]}
                  onChange={(event) => {
                    field.onChange(event.value);
                    let newSortedArr = doSort(event.value, caseList);
                    setCaseList(newSortedArr)
                  }}
                />
              )}
            />
          </div> */}

          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            footer={caseList.length > 0 && <PrimeTableFooter rowDataList={caseList} isShowMore={true} btnReadMore={btnReadMore} />}
            value={caseList}
            emptyMessage={<NoInfo panel="table"/>}
          >

            <Column body={orderNoTemplate} header={t('seqNo')} />
            <Column field="year" sortable header={t('queryYear')} />
            <Column field="placeName" header={t('place_name')} />
            {/* <Column field="caseSn" header={t('caseNo')} /> */}
            <Column field="caseSn" body={(rowData, columnProps) => {
              return (
                <span style={{ cursor: "pointer" }} onClick={() => { handleCaseSnLink(rowData) }}>{rowData?.caseSn}</span>
              )
            }} header={t('caseNo')} />
            <Column field="uploaderCompanyName" header={t('uploader')} />
            <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} />

          </DataTable>
        </div>
      </div>
      {/* 新增 Dialog */}
     
      <PrimeDialog
        visible={addDialog}
        loading={confirmLoad}
        onClose={() => { 
          setAddDialog(false);
          clearErrors(["add_companySeq","add_placeSeq","add_year","add_file"]);
          fileInputRef.current.value = null;
         }}
        onConfirm={() => { confirmAddReg(); }}
        disabledConfirm={!isValid}
        title={t('button.add')}
        size="lg"
        bodyTemplate={
          <AddReg
            addDialog={addDialog}
            setValidForm = {setValidForm}
            trigger={trigger}
            watch={watch}
            getValues={getValues}
            control={control}
            errors={errors}
            currentMinGuoYear={currentMinGuoYear}
            currentYear={currentYear}
            setValue={setValue}
            register={register}
            fileInputRef = {fileInputRef}
            planYearList={planYearList}
          />
        }
      />
      {/* 刪除Dialog */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => { setDelDialog(false) }}
        onConfirm={() => { confirmDel(); }}
        title={delTitle}
        bodyTemplate={delContent}
      />
    </>
  )
}

export default DataReg_Index